(() => {
  if (customElements.get('slider-articles')) {
    return;
  }

  class SliderArticles extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        slidesPerView: 1.33,
        spaceBetween: 16,
        navigation: {
          prevEl: this.querySelector('[data-arrow-prev]'),
          nextEl: this.querySelector('[data-arrow-next]'),
        },
        breakpoints: {
          768: {
            slidesPerView: 4,
            autoHeight: false,
          },
        },
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.slider = new Swiper(this, this.options);
    }
  }

  customElements.define('slider-articles', SliderArticles);
})();
